export default function TableSkeletonBody({ colSpan = 3, rowSpan = 3 }) {
  return (
    <>
      <div className="preloader-isload"></div>
      {Array.from({ length: rowSpan }, (_, i) => (
        <tr key={`${i}-tr`}>
          {Array.from({ length: colSpan }, (_, index) => (
            <td className="my-auto text-center" key={index}>
              <span className="placeholder col-12"></span>
            </td>
          ))}
        </tr>
      ))}
    </>
  )
}
